export interface ElectronicInvoiceAddress {
    type: 'Peppol' | 'Finvoice';
    value: string;
}

export const getElectronicInvoiceDisplayValue = (address: ElectronicInvoiceAddress): string => {
    return address.value ?? '';
};
